import useGetAuthenticate from "hooks/useIsAuthenticatedUser";
import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { privateRoutes } from "./navigation/navigationRoutes/private";
import { privateRoutesCabinet } from "./navigation/navigationRoutes/privateCabinet";
import { publicRoutes } from "./navigation/navigationRoutes/public";
import { NOTFOUND_PATH } from "./navigation/navigationPaths";
import PageNotFound from "pages/NotFound/PageNotFound";
import useGetCurrentUser from "hooks/useGetCurrentUser";
import RAGInitializer from "components/RAGInitialiser/RAGInitializer";
// import ProfileErrorPage from "pages/ProfileErrorPage/ProfileErrorPage"; // This line is removed as per the instruction
// import { router } from "./navigation";

function Roots() {
  const isAuthenticated = useGetAuthenticate();

  const currentUser = useGetCurrentUser();

  const router = isAuthenticated
    ? currentUser?.status === "ENTREPRISE"
      ? createBrowserRouter([
        ...privateRoutes,
        {
          path: NOTFOUND_PATH,
          element: <PageNotFound />,
        },
      ])
      : createBrowserRouter([
        ...privateRoutesCabinet,
        {
          path: NOTFOUND_PATH,
          element: <PageNotFound />,
        },
      ])
    : createBrowserRouter([
      ...publicRoutes,
      {
        path: NOTFOUND_PATH,
        element: <PageNotFound />,
      },
    ]);
  return (
    <>
      {/* Initialiser le service RAG au démarrage */}
      <RAGInitializer />
      
      {/* Router de l'application */}
      <RouterProvider router={router} fallbackElement={<p>Chargement...</p>} />
    </>
  );
}

export default Roots;
